import { useLang } from "../store";
import { PageHead, Reveal } from "../components/Reveal";
import Footer from "../components/Footer";

const TRAILERS = [
  { id: "cYlANpe2N-M", film: "L'equilibrista con la stella" },
  { id: "aDtYZG9SGDw", film: "Nessun domani" },
  { id: "Ogaajya9-T8", film: "Tre storie straordinarie" },
];

export default function Screening() {
  const { t } = useLang();

  return (
    <div className="min-h-screen" data-testid="screening-page">
      <PageHead kicker="SALA 7 · PROIEZIONI PRIVATE" title={t("screening.title")} sub={t("screening.sub")} />

      <div className="mx-auto max-w-[1600px] px-6 pb-24">
        <div className="grid max-w-[980px] grid-cols-1 gap-4 sm:grid-cols-3" data-testid="trailer-row">
          {TRAILERS.map((tr, i) => (
            <Reveal key={tr.id} delay={i * 0.08}>
              <div className="overflow-hidden rounded border border-white/10 bg-black" data-testid={`trailer-${tr.id}`}>
                <div className="aspect-video w-full">
                  <iframe
                    src={`https://www.youtube.com/embed/${tr.id}`}
                    title={`Trailer ${tr.film}`}
                    className="h-full w-full"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </div>
                <p className="font-mono2 border-t border-white/10 px-3 py-2 text-[10px] uppercase leading-snug tracking-[0.12em] text-slate-400">
                  {t("screening.trailerCta")} <span className="text-amber-500">{tr.film}</span>
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="font-serif-it mt-8 max-w-[980px] text-lg italic text-slate-400" data-testid="screening-contact-note">
            {t("screening.cinemaNote")}{" "}
            <a href="mailto:info@thepalmamovie.com" className="not-italic text-amber-500 underline-offset-4 transition-colors hover:text-amber-400 hover:underline" data-testid="screening-contact-email">
              info@thepalmamovie.com
            </a>
            .
          </p>
        </Reveal>
      </div>
      <Footer />
    </div>
  );
}
